import * as React from 'react';

interface BelfiusTextProps {
  children: React.ReactNode;
  [key: string]: any; // This allows other props to be passed as well
}

class BelfiusText extends React.PureComponent<BelfiusTextProps> {
  render() {
    return (
      <span {...this.props}>{this.props.children}</span>
    );
  }
}

export { BelfiusText };
